'use strict';

import { api } from '../../utils/api-interceptor.js';

export const getDataOfFile = () =>
  api('news?temporal=' + Math.floor(Math.random() * 1000), { hasLang: true });
